import { render, staticRenderFns } from "./Referral.vue?vue&type=template&id=4f0195c4&scoped=true"
import script from "./Referral.vue?vue&type=script&lang=js"
export * from "./Referral.vue?vue&type=script&lang=js"
import style0 from "./Referral.vue?vue&type=style&index=0&id=4f0195c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0195c4",
  null
  
)

export default component.exports